function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "grass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.3,
    y: -0.47,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "outside"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878,549.94c-2.49,2-5,4.12-7.53,6.26q-7.94,6.69-16.05,14.09-2.05,1.85-4.12,3.76c0,.05-.11.09-.16.15-2.7,2.49-5.4,5-8.13,7.63a1.14,1.14,0,0,1-.16.15c-2.72,2.6-5.46,5.23-8.2,8l-4.37,4.32c-1.75,1.75-3.48,3.51-5.25,5.3q-3.94,4-7.91,8.15l-2.66,2.79c-1.76,1.86-3.54,3.75-5.31,5.65a1.06,1.06,0,0,1-.15.15q-8.65,9.29-17.44,19.18l-5.85,6.65c-1,1.13-1.94,2.25-2.93,3.39-3.41,4-6.86,8-10.29,12.07s-6.89,8.23-10.34,12.44L758,673.92c-1.05,1.3-2.1,2.61-3.17,3.92q-3.18,4-6.36,8t-6.34,8.06q-3.18,4.08-6.37,8.23-7.63,9.95-15.28,20.27a.83.83,0,0,1-.13.18q-5.44,7.35-10.87,14.89l-4.08,5.68q-14.25,20-28.43,41.14H814.8c41-93.09,66.93-178,75.34-243.73a1,1,0,0,0,0-.17C886.15,543.4,882.07,546.62,878,549.94Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.33,540.2l-.19.33L749.38,784.26H677q14.16-21.16,28.4-41.14l4.08-5.68q5.43-7.53,10.87-14.89a.83.83,0,0,0,.13-.18q7.65-10.3,15.28-20.27,3.19-4.15,6.37-8.24l6.34-8.05q3.18-4,6.36-8c1.07-1.31,2.12-2.63,3.17-3.93l3.15-3.84h0q5.19-6.34,10.34-12.47c3.43-4.09,6.88-8.11,10.29-12.07,1-1.14,2-2.26,2.93-3.4,2-2.22,3.91-4.44,5.85-6.64q8.78-9.88,17.44-19.18a1.14,1.14,0,0,0,.15-.16c1.77-1.9,3.55-3.78,5.31-5.64l2.66-2.79q4-4.14,7.91-8.15c1.77-1.79,3.5-3.56,5.25-5.31l4.37-4.32q4.11-4,8.2-7.95l.16-.15c2.73-2.6,5.43-5.15,8.13-7.63,0-.06.11-.1.16-.16q2.07-1.9,4.12-3.76,8.1-7.38,16.05-14.08,3.79-3.23,7.53-6.26Q884.22,544.82,890.33,540.2Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.5,411.88l-.4.44c-22.41,24.31-45.64,54.87-68.9,90.64-1.19,1.82-2.38,3.66-3.55,5.52-17.15,26.75-34.27,56.28-51.06,88.17-29.52,56-58,119.35-83.77,187.61h143c12.55-39.15,23.34-77.39,32.31-114.19h0v0C785.71,569.29,796.73,479.43,793.5,411.88Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.28,411.82l-.18.5L658.43,784.26H586.35c25.57-68.08,53.87-131.25,83.2-187.19,16.8-32.05,33.94-61.72,51.1-88.59,1.17-1.86,2.36-3.7,3.55-5.52C747.5,467,770.8,436.25,793.28,411.82Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.83,272c-.1-.43-.2-.86-.29-1.28s-.17-.75-.25-1.12c-.19.3-.38.58-.56.89-35.22,55-69.32,133.87-98,227.9v0c-19.28,63.17-36.13,133.19-49.21,207.41q-7,39.78-12.14,78.4H640.62q5.52-26.67,10.36-54.16c8-45.59,14.21-90.15,18.57-133,0-.15,0-.29,0-.42C682.8,466.67,679.5,352.18,661.83,272Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.88,269.64l-.15.89-.27,1.51L570,784.26h-69.2Q506,745.68,513,705.81c12.95-73.33,29.55-142.53,48.57-205.08h0c.35-1.15.69-2.32,1.05-3.46,28.6-93.37,62.54-171.7,97.57-226.5Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.91,500.73h0l-.2-2.27v0c0-.4-.07-.78-.11-1.17-11.23-126.35-34.77-234.65-65.91-308.9-31.6,75.4-55.37,185.82-66.39,314.6v0c-4.43,51.66-6.8,106.29-6.8,162.77,0,40.61,1.23,80.25,3.57,118.51H566.33c2.34-38.26,3.57-77.9,3.57-118.51C569.9,608.45,567.45,553.06,562.91,500.73Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.91,500.73h0l-.2-2.27v0c0-.4-.07-.78-.11-1.17-11.23-126.35-34.77-234.65-65.91-308.9-31.6,75.4-55.37,185.82-66.39,314.6v0c-4.43,51.66-6.8,106.29-6.8,162.77,0,40.61,1.23,80.25,3.57,118.51H566.33c2.34-38.26,3.57-77.9,3.57-118.51C569.9,608.45,567.45,553.06,562.91,500.73Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.69,188.36v595.9H427.07c-2.34-38.26-3.57-77.9-3.57-118.51,0-56.48,2.37-111.11,6.8-162.77v0C441.32,374.18,465.09,263.76,496.69,188.36Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.31,784.26H351q-5.47-26.57-10.33-54c-8.06-45.72-14.23-90.44-18.61-133.44-13.34-131.29-9.84-246.77,8.3-327,36,55.89,70.79,136.69,99.92,233.13v0a1773.23,1773.23,0,0,1,47.89,203.07Q485.2,745.73,490.31,784.26Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.09,784.26H351q-5.47-26.57-10.33-54c-8.06-45.72-14.23-90.44-18.61-133.44-13.34-131.29-9.84-246.77,8.3-327Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.78,784.26H262.84c-12.54-39.08-23.3-77.26-32.27-114h0C206,569.49,195,479.62,198.18,412.07c40.2,43.5,83,107.16,123.9,184.78C351.58,652.83,380.05,716.08,405.78,784.26Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.78,784.26H262.84c-12.54-39.08-23.3-77.26-32.27-114h0C206,569.49,195,479.62,198.18,412.07c40.2,43.5,83,107.16,123.9,184.78C351.58,652.83,380.05,716.08,405.78,784.26Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.64,784.26h-70.8c-12.54-39.08-23.3-77.26-32.27-114h0C206,569.49,195,479.62,198.18,412.07Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.62,784.26H176.81c-40.94-93.09-66.92-178-75.29-243.71,39.76,30.21,84,74.57,129.05,129.7h0C258.53,704.39,286.81,742.65,314.62,784.26Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.62,784.26H176.81c-40.94-93.09-66.92-178-75.29-243.71,39.76,30.21,84,74.57,129.05,129.7h0C258.53,704.39,286.81,742.65,314.62,784.26Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.22,784.26H176.81c-40.94-93.09-66.92-178-75.29-243.71Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrass);
export default __webpack_public_path__ + "static/media/grass.de73f15afffde6d47e2346db3f33d0c0.svg";
export { ForwardRef as ReactComponent };